module.exports = __webpack_public_path__ + "static/media/delete-icon.c8f230b6.svg";